import axios from "axios";
import {toast} from "react-toastify";

export default class ProjectService {

    constructor() {
    }

    downloadProjectTemplate = (templateType:string) => {
        const url = `/api/auth/downloadProjectTemplate/${templateType}`;

        return new Promise((resolve, reject) => {
            axios.get(url, {
                responseType: 'arraybuffer'
            }).then(resp => {
                resolve(resp);
            }).catch(err => {
                if(!err.response.data.badToken) {
                    reject(new Error(`Error downloading file - ${err.response.data.message}`));
                }
            });
        });
    };
}